module.exports = __webpack_public_path__ + "img/grad-1.f16a231f.svg";